import { FileQuotaExceededEvent } from '@rematter/frontend-lib-api-client/grpc/files/v1/file_events_pb';
import { Col, humanReadableDateTime } from '@rematter/ui-web';
import { FieldDisplay, IDField } from '@rematter/ui-web';

import { protoTimestampToZonedDateTimeString } from '@/audit-log/_components/_shared';
import { getLocale } from '~/shared/utils/locale';

type FileQuotaExceededDetailProps = {
  event: FileQuotaExceededEvent;
};

const formatFileSize = (size: bigint | number): string => {
  const bytes = Number(size);
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const FileQuotaExceededDetail = ({
  event,
}: FileQuotaExceededDetailProps) => {
  const attemptedAtStr = protoTimestampToZonedDateTimeString(event.attemptedAt);

  return (
    <Col className="@FileQuotaExceededDetail gap-3" gap3>
      <Col
        className="rounded-md border border-warning/20 bg-warning/5 p-3"
        gap2
      >
        <span className="text-xs font-medium text-warning/80">
          Quota Exceeded Details
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField
            label="Organization ID"
            value={event.organizationId?.value}
          />
          <IDField label="User ID" value={event.userId?.value} />
          <FieldDisplay label="File Name" value={event.fileName} />
          <FieldDisplay
            label="Attempted Size"
            value={formatFileSize(event.attemptedSize)}
          />
          <FieldDisplay
            label="Current Usage"
            value={formatFileSize(event.currentUsage)}
          />
          <FieldDisplay
            label="Quota Limit"
            value={formatFileSize(event.quotaLimit)}
          />
          {attemptedAtStr && (
            <FieldDisplay
              label="Attempted At"
              value={humanReadableDateTime(attemptedAtStr, {
                locale: getLocale(),
              })}
            />
          )}
        </div>
      </Col>
    </Col>
  );
};
